import PropTypes from 'prop-types';

export const UserResource = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    username: PropTypes.string.isRequired,
    profile_image: PropTypes.shape({
        medium: PropTypes.string.isRequired,
        small: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    }).isRequired,
    profile_link: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
};
